<template>
  <div class="x-page-container">
    <div class="x-page-container-header" v-if="showHeader" :style="{minHeight: headerMinHeight}">
      <slot name="header"></slot>
    </div>
    <div class="x-page-container-sub" v-if="showSub">
      <slot name="sub"></slot>
    </div>
    <div class="x-page-container-main" v-if="showMain">
      <slot name="main"></slot>
    </div>
    <div class="x-page-container-footer" v-if="showFooter">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XPageContainer',
  inheritAttrs: false,
  props: {
    headerMinHeight: {
      type: String,
      default: 'auto'
    }
  },
  computed: {
    showHeader () {
      const arr = this.$scopedSlots.header ? this.$scopedSlots.header() : [];
      return Array.isArray(arr) && arr.length > 0;
    },
    showSub () {
      const arr = this.$scopedSlots.sub ? this.$scopedSlots.sub() : [];
      return Array.isArray(arr) && arr.length > 0;
    },
    showMain () {
      const arr = this.$scopedSlots.main ? this.$scopedSlots.main() : [];
      return Array.isArray(arr) && arr.length > 0;
    },
    showFooter () {
      const arr = this.$scopedSlots.footer ? this.$scopedSlots.footer() : [];
      return Array.isArray(arr) && arr.length > 0;
    }
  }
};
</script>
<style lang="scss">
.x-page-container {
  box-sizing: border-box;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.x-page-container-header, .x-page-container-sub, .x-page-container-footer {
  flex: 0 0 auto;
}

.x-page-container-main {
  flex: 1 0 0;
  height: 0;
}
</style>